<template>
  <div id="position_code_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span v-if="isEditPage" class="page-title" id="positionCodeHeader">Update Position Code</span>
          <span v-else class="page-title" id="positionCodeHeader">Add Position Code</span>
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackPositionCodeList">
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content position-code-create">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select"
                    id="PositionCodeForm">
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label require" for="position_code"> Position Code:</label>
                    <input type="text" class="form-control" v-model="position_code" id="position_code"
                           placeholder="Enter Position Code" name="position_code" :disabled="disableFormFields">
                    <div class="field-error">{{ position_code_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="system"> System:</label>
                    <input type="text" class="form-control" v-model="system" id="system" placeholder="Enter System"
                           name="system" :disabled="disableFormFields">
                    <div class="field-error">{{ system_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="sub_system"> Sub System:</label>
                    <input type="text" class="form-control" v-model="sub_system" id="sub_system"
                           placeholder="Enter Sub System" name="sub_system" :disabled="disableFormFields">
                    <div class="field-error">{{ sub_system_error_msg }}</div>
                  </div>


                </div>
                <div class="from-group">
                  <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <strong id="errorMsg" class="field-error"></strong>
                  </div>
                </div>
                <div class="btn-groups">
                  <button v-if="isEditPage" type="submit" id="createPositionCodeBtn" class="btn btn-primary"
                          v-on:click.prevent="CreatePositionCode" :disabled="disableFormFields">
                    <i class="fp-reload"> </i> Update
                  </button>
                  <button v-else type="submit" id="createPositionCodeBtn" class="btn btn-primary"
                          v-on:click.prevent="CreatePositionCode" :disabled="disableFormFields">
                    <i class="fp-reload"> </i> Create
                  </button>

                  <button type="submit" id="cancelPositionCodeBtn" class="btn btn-tertiary"
                          v-on:click.prevent="BackPositionCodeList">
                    <i class="fp-close"> </i> Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {commonMixins} from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";

Vue.component("loading-content", LoadingContent);

export default {
  name: "PositionCodeCreate",
  components: {
    appFooter: () => import('@/components/Footer')
  },
  metaInfo() {
    return {
      title: (this.$route.params.id > 0) ? "Update Position Code | " + process.env.COPYRIGHT_NAME : "Create Position Code | " + process.env.COPYRIGHT_NAME
    }
  },
  mixins: [commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    position_code: "",
    system: "",
    sub_system: "",
    velocity_env: process.env.NODE_ENV,
    isEditPage: false,
    position_code_error_msg: "",
    system_error_msg: "",
    sub_system_error_msg: "",
    positionCodeId: null,
    loading: false,
    disableFormFields: false,
  }),
  watch: {
    permissions: function (permissions) {
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (element.name === 'ev_create_position_code') {
            this.cantAccessPage = true;
          }
        }
      }
    }
  },

  mounted: function () {
    this.getPermissions();
    if (this.$route.params.id > 0) {
      this.isEditPage = true;
      this.positionCodeId = this.$route.params.id;
      this.loadPositionCodeData();
    }
  },
  methods: {
    BackPositionCodeList() {
      this.$router.push("/position-code/list");
    },
    CreatePositionCode() {
      var self = this;
      let validity = this.validatePositionCodeFields();
      if (validity) {
        self.loading = true;
        this.disableButtons();
        var fields = this.preparePositionCodeFields();
        $.ajax({
          url: process.env.ROOT_API + "/position-code/create",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            self.enableButtons();
            if (data.status === "success") {
              self.$router.push("/position-code/list");
            } else {
              $("#errorMsg").html(data.message);
              $(".alert-warning").toggleClass("show");
              setTimeout(function () {
                $(".alert-warning").removeClass("show");
                $(".alert-warning").addClass("hide");
              }, 10000);
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR,false,'load-position-code');
            self.enableButtons();
          }
        })
      }
    },
    validatePositionCodeFields() {
      this.position_code_error_msg = "";
      this.system_error_msg = "";
      this.sub_system_error_msg = "";
      let validity = true;

      if (this.position_code === "") {
        this.position_code_error_msg = "Position Code is Required!";
        validity = false;
      }

      if (this.system === "") {
        this.system_error_msg = "System is Required!";
        validity = false;
      }

      if (this.sub_system === "") {
        this.sub_system_error_msg = "Sub System is Required!";
        validity = false;
      }

      return validity;
    },
    preparePositionCodeFields() {
      var fields = $('#PositionCodeForm').serializeArray();
      fields.push({name: "position_code_id", value: this.positionCodeId});

      return fields;
    },
    disableButtons() {
      if (this.isEditPage) {
        $("#createPositionCodeBtn").val("Updating ...");
        $("#createPositionCodeBtn").prop("disabled", true);
        $("#cancelPositionCodeBtn").prop("disabled", true);
      } else {
        $("#createPositionCodeBtn").val("Saving ...");
        $("#createPositionCodeBtn").prop("disabled", true);
        $("#cancelPositionCodeBtn").prop("disabled", true);
      }
    },
    enableButtons() {
      if (this.isEditPage) {
        $("#createPositionCodeBtn").val("Update");
        $("#createPositionCodeBtn").prop("disabled", false);
        $("#cancelPositionCodeBtn").prop("disabled", false);
      } else {
        $("#createPositionCodeBtn").val("Create");
        $("#createPositionCodeBtn").prop("disabled", false);
        $("#cancelPositionCodeBtn").prop("disabled", false);
      }
    },
    loadPositionCodeData() {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/position-code/" + self.positionCodeId,
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            self.position_code = data.content.code;
            self.system = data.content.system;
            self.sub_system = data.content.sub_system;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR,false,'load-position-code');
          self.disableFormFields = true;
          if (jqXHR.status === 0) {
            self.errorMsg = "Remote server cannot be reached";
          } else {
            //redirect to login page if user not authenticated
            if (jqXHR.status === 401) {
              //clear previous data
              localStorage.removeItem("user_obj");
              localStorage.removeItem("tkn");

              self.$router.push("/");
            }
            self.error = jqXHR.responseJSON.message;
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PositionCodeCreate.vue